import { Action, Dispatch } from 'redux';

import { State } from '../../../weborder/Store';
import { getOrderHistory, getReorders } from '../../api/order/order.service';
import {
  GetOrderHistoryQueryParams,
  GetReordersQueryParams,
  OrderHistory,
} from '../../api/order/order.types';
import { Status } from '../../types/data.types';
import { selectAppConfig } from '../whitelabel/whitelabelSelectors';
import { ReorderType } from './order.types';
import { setOrderHistory, setReorders } from './orderActions';

export const loadOrderHistory =
  () =>
  async (dispatch: Dispatch<Action>, getState: () => State): Promise<void> => {
    const state = getState();
    const appConfigData = selectAppConfig(state);

    if (appConfigData) {
      const queryParams: GetOrderHistoryQueryParams = {
        count: 50,
        skip: 0,
        wlid: appConfigData.WhiteLabelId,
      };

      await getOrderHistory(queryParams)
        .then((data: OrderHistory[]) => {
          dispatch(
            setOrderHistory({
              data,
              status: 'success',
            }),
          );
        })
        .catch(() => {
          dispatch(
            setOrderHistory({
              status: 'none',
            }),
          );
        });
    }
  };

export const loadReorders =
  (
    queryParams: GetReordersQueryParams,
    reorderType: ReorderType,
    prId?: number,
  ) =>
  (dispatch: Dispatch<Action>): Promise<void> =>
    getReorders(queryParams)
      .then((data) => {
        dispatch(
          setReorders(
            {
              data,
              status: Status.SUCCESS,
            },
            reorderType,
            prId,
          ),
        );
      })
      .catch(() => {
        dispatch(
          setReorders(
            {
              status: Status.ERROR,
            },
            reorderType,
            prId,
          ),
        );
      });
